<template>
    <div class="flex flex-col w-full min-w-[160px] md:w-[160px] h-full">
        <div class="flex flex-col space-y-4 w-full md:pr-8">
            <div class="pb-6">
                <div class="rounded-md border border-gray-300 md:border-none">
                    <tracked-link v-for="(quicklink, index) in quickLinks" :key="index" :link="quicklink" class="text-sm text-gray-500 hover:text-gray-700 cursor-pointer w-full flex items-center justify-start md:justify-end px-2 py-1.5 md:px-0 odd:bg-gray-50 even:bg-gray-100 border-gray-300 border-b first:rounded-t-md last:border-none md:even:bg-gray-100 md:odd:bg-gray-100 md:border-none last:rounded-b-md " :class="getQuickLinkClass(quicklink)">{{ quicklink.label }}</tracked-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import TrackedLink from '../nav-bar-link-components/TrackedLink.vue';

const props = defineProps(['quickLinks', 'routePath'])

function getQuickLinkClass(quickLink) {
    if(quickLink.path == props.routePath || quickLink.path == `${props.routePath}/`) {
        return 'font-bold text-gray-800'
    } else {
        return ''
    }
}
</script>